export const CommunityTypeIdEnum = {
  lookupTypeId: 19,
};
